import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyThuChiNgoaiLeApi from "service/quanLyThuChiNgoaiLeApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import BaoCaoChiNhanhApi from "../../../service/TongChiNhanh/BaoCaoChiNhanhApi";
export const ModalChiTietDangChoVay = (props) => {
    useEffect(() => {
        ThongKeDangChoVay_CamDo(props.macuahang);
        ThongKeDangChoVay_TinChap(props.macuahang);
        ThongKeDangChoVay_TraGop(props.macuahang);
    }, []);


    const [chovaycamdo, setChoVayCamDo] = useState([]);
    const ThongKeDangChoVay_CamDo = (macuahang) => {
        BaoCaoChiNhanhApi.ThongKeDangChoVay_CamDo(macuahang).then((response) => {
            setChoVayCamDo(response.data)
        });
    };


    const [chovaytinchap, setChoVayTinChap] = useState([]);
    const ThongKeDangChoVay_TinChap = (macuahang) => {
        BaoCaoChiNhanhApi.ThongKeDangChoVay_TinChap(macuahang).then((response) => {
            setChoVayTinChap(response.data)
        });
    };


    const [chovaytragop, setChoVayTraGop] = useState([]);
    const ThongKeDangChoVay_TraGop = (macuahang) => {
        BaoCaoChiNhanhApi.ThongKeDangChoVay_TraGop(macuahang).then((response) => {
            setChoVayTraGop(response.data)
        });
    };


    return (
        <Modal
            {...props}
            size="modal-new-size modal-new-size"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left popup-detail"

        >
            <Modal.Header style={{ borderRadius: "10px" }}>
                <h4 className="modal-title" id="myModalLabel16" style={{ paddingTop: "10px", paddingLeft: "15px" }}>
                    Đang cho vay
                    <br />
                    <span className="span_iconCus">
                        <i class="mdi mdi-check" style={{ marginTop: "-2px" }}></i></span>
                    <span style={{ marginTop: "2px", color: '#6B6F82', fontSize: '14px' }}>{props.cuahang}</span>
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={props.onHide}
                    style={{ padding: "20px" }}
                >
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ paddingTop: "0px", paddingBottom: "0px", backgroundColor: "#FFF" }}>
                <form className="form tat-toan form-horizontal">
                    <div className="form-body" >
                        <div className="card collapse-icon accordion-icon-rotate">
                            <div className="row">
                                <div className="col-md-4" style={{ padding: "15px 15px 35px 15px", }}>
                                    <div className="divbaocaochinhanh-cuahangchitiet">
                                        <div className="title" style={{ textAlign: "center" }}>Cầm đồ</div>
                                        <table className="content_table3">
                                            <thead>
                                                <tr>
                                                    <th style={{ textAlign: "left" }}>LOẠI</th>
                                                    <th style={{ textAlign: "center" }}>SỐ LƯỢNG</th>
                                                    <th style={{ textAlign: "right", }}>TỔNG TIỀN</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Đang cho vay</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaycamdo.HopDong_DangChoVay_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaycamdo.HopDong_DangChoVay_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Đủ lãi</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaycamdo.HopDong_DuLai_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaycamdo.HopDong_DuLai_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Nợ lãi</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaycamdo.HopDong_NoLai_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaycamdo.HopDong_NoLai_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Quá hạn</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaycamdo.HopDong_QuaHan_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaycamdo.HopDong_QuaHan_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Đóng</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaycamdo.HopDong_Dong_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaycamdo.HopDong_Dong_TongTien)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className="content_table3">
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: "left", verticalAlign: "top" }}><b>Nợ phải thu</b></td>
                                                    <td style={{ textAlign: "center" }}><span style={{ color: "#a8a8a8" }}>Số hợp đồng</span><br /><b style={{ color: "#c0392b" }}>{formatNumber(chovaycamdo.NoPhaiThu_SoLuong)}</b></td>
                                                    <td style={{ textAlign: "right", }}><span style={{ color: "#a8a8a8" }}>Tổng tiền</span><br /><b style={{ color: "#c0392b" }}>{formatNumber(chovaycamdo.NoPhaiThu_TongTien)}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-4" style={{ borderLeft: "1px solid #e5e5e5", padding: "15px 15px 35px 15px" }}>
                                    <div className="divbaocaochinhanh-cuahangchitiet">
                                        <div className="title" style={{ textAlign: "center" }}>Tín chấp</div>
                                        <table className="content_table3">
                                            <thead>
                                                <tr>
                                                    <th style={{ textAlign: "left" }}>LOẠI</th>
                                                    <th style={{ textAlign: "center" }}>SỐ LƯỢNG</th>
                                                    <th style={{ textAlign: "right", }}>TỔNG TIỀN</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Đang cho vay</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytinchap.HopDong_DangChoVay_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytinchap.HopDong_DangChoVay_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Đủ lãi</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytinchap.HopDong_DuLai_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytinchap.HopDong_DuLai_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Nợ lãi</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytinchap.HopDong_NoLai_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytinchap.HopDong_NoLai_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Quá hạn</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytinchap.HopDong_QuaHan_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytinchap.HopDong_QuaHan_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Đóng</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytinchap.HopDong_Dong_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytinchap.HopDong_Dong_TongTien)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className="content_table3">
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: "left", verticalAlign: "top" }}><b>Nợ phải thu</b></td>
                                                    <td style={{ textAlign: "center" }}><span style={{ color: "#a8a8a8" }}>Số hợp đồng</span><br /><b style={{ color: "#c0392b" }}>{formatNumber(chovaytinchap.NoPhaiThu_SoLuong)}</b></td>
                                                    <td style={{ textAlign: "right", }}><span style={{ color: "#a8a8a8" }}>Tổng tiền</span><br /><b style={{ color: "#c0392b" }}>{formatNumber(chovaytinchap.NoPhaiThu_TongTien)}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-4" style={{ borderLeft: "1px solid #e5e5e5", padding: "15px 15px 35px 15px" }}>
                                    <div className="divbaocaochinhanh-cuahangchitiet">
                                        <div className="title" style={{ textAlign: "center" }}>Trả góp</div>
                                        <table className="content_table3">
                                            <thead>
                                                <tr>
                                                    <th style={{ textAlign: "left" }}>LOẠI</th>
                                                    <th style={{ textAlign: "center" }}>SỐ LƯỢNG</th>
                                                    <th style={{ textAlign: "right", }}>TỔNG TIỀN</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Đang cho vay</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytragop.HopDong_DangChoVay_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytragop.HopDong_DangChoVay_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Đủ lãi</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytragop.HopDong_DuLai_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytragop.HopDong_DuLai_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Nợ lãi</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytragop.HopDong_NoLai_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytragop.HopDong_NoLai_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Quá hạn</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytragop.HopDong_QuaHan_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytragop.HopDong_QuaHan_TongTien)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>Đóng</td>
                                                    <td style={{ textAlign: "center" }}>{formatNumber(chovaytragop.HopDong_Dong_SoLuong)}</td>
                                                    <td style={{ textAlign: "right", }}>{formatNumber(chovaytragop.HopDong_Dong_TongTien)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className="content_table3">
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: "left" , verticalAlign: "top"}}><b>Nợ phải thu</b></td>
                                                    <td style={{ textAlign: "center" }}><span style={{ color: "#a8a8a8" }}>Số hợp đồng</span><br /><b style={{ color: "#c0392b" }}>{formatNumber(chovaytragop.NoPhaiThu_SoLuong)}</b></td>
                                                    <td style={{ textAlign: "right", }}><span style={{ color: "#a8a8a8" }}>Tổng tiền</span><br /><b style={{ color: "#c0392b" }}>{formatNumber(chovaytragop.NoPhaiThu_TongTien)}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            {/* <Modal.Footer className="modal-footer button-popup-new-size">
                <a
                    className="btn btn-new-main btn-closenew"
                    data-dismiss="modal"
                    href={() => false}
                    onClick={props.onHide}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-close"></i>
                    </span>{" "}
                    Đóng
                </a>
            </Modal.Footer> */}
        </Modal>
    );
};
